"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.releaseNewsUrl = exports.sinceRelease = exports.isReleased = undefined;

var _flags = require("./flags");

Object.keys(_flags).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _flags[key];
    }
  });
});

var _criteria = require("./criteria");

var _release = require("./release");

exports.isReleased = _criteria.isReleased;
exports.sinceRelease = _criteria.sinceRelease;
exports.releaseNewsUrl = _release.newsUrl;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvZmxhZ3MvaW5kZXguanMiXSwibmFtZXMiOlsiaXNSZWxlYXNlZCIsInNpbmNlUmVsZWFzZSIsInJlbGVhc2VOZXdzVXJsIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFHQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBRkE7O0FBQ0E7O1FBRVFBLFU7UUFBWUMsWTtRQUFjQyxjIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCB7aXNSZWxlYXNlZCwgc2luY2VSZWxlYXNlfSBmcm9tIFwiLi9jcml0ZXJpYVwiXG5pbXBvcnQge25ld3NVcmwgYXMgcmVsZWFzZU5ld3NVcmx9IGZyb20gXCIuL3JlbGVhc2VcIlxuZXhwb3J0ICogZnJvbSBcIi4vZmxhZ3NcIlxuZXhwb3J0IHtpc1JlbGVhc2VkLCBzaW5jZVJlbGVhc2UsIHJlbGVhc2VOZXdzVXJsfVxuIl19


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/flags/index.js
// module id = 363
// module chunks = 0